export default __webpack_public_path__ + "static/media/block-2.fe4bafd5.png";